import { Box, Button, Container, Grid, Heading, Image, Input, Select, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import cursor from '../../../assets/images/cursor.png'
import Slidebar from '../Slidebar'
import { fileUploadCss } from '../../auth/Register'
const CreateCourse = () => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [createdBy, setCreatedBy] = useState('')
  const [category, setCategory] = useState('')
  const [image, setImage] = useState('')
  const [imagePrev, setImagePrev] = useState('')
  const categories=[
    "Web Development","Artificial Intellegence","Data Structure & Algorithm","Data Science","App Development","Many More"
 ]

const changeImageHandler=(e)=>{
   const file=e.target.files[0];
   const reader=new FileReader();
   reader.readAsDataURL(file)
   reader.onloadend=()=>{
       setImagePrev(reader.result)
       setImage(file)
   }
}

  return (
    <Grid minH={'100vh'} css={{cursor:`url(${cursor}),default`}} templateColumns={['1fr','5fr 1fr']}>
        <Container py='16' >
<form >


<Heading textTransform={'uppercase'} children="Create Course" my='16' textAlign={['center','left']} />
<VStack m='auto' spacing={'8'}>
<Input value={title} onChange={(e)=>setTitle(e.target.value)} type='text' focusBorderColor='purple.300' placeholder="Title"  />
<Input value={description} onChange={(e)=>setDescription(e.target.value)} type='text' focusBorderColor='purple.300' placeholder="Description"  />
<Input value={createdBy} onChange={(e)=>setCreatedBy(e.target.value)} type='text' focusBorderColor='purple.300' placeholder="Created Name"  />


<Select focusBorderColor='purple.300' value={category} onChange={(e)=>setCategory(e.target.value)}>
{categories.map((item)=>(
<option key={item} value={item}>{item}</option>

))}
</Select>

<Input accept='image/*' required id='chooseAvatar'  type={'file'} focusBorderColor='purple.300' css={{ "&:: file-selector-button":{
  ...fileUploadCss,color:'purple'
}}} onChange={changeImageHandler} />
{imagePrev && (
  <Image src={imagePrev} boxSize='64' objectFit={'contain'} />
)}
<Button w='full' colorScheme={'purple'} type='submit'>Create</Button>
</VStack>
</form>
        </Container>
        <Slidebar/>
    </Grid>
  )
}

export default CreateCourse